import dateFormat from 'dateformat'

export const formatDateBackwards = (date: Date) => dateFormat(new Date(), "yyyymmdd")